import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHand = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M5.984,21H4a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H5.984a1,1,0,0,1,1,1v6A1,1,0,0,1,5.984,21Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M12.96,17h2.324a1.984,1.984,0,0,0,1.195-.4l2.406-1.812a1.5,1.5,0,0,1,1.972.141h0a1.519,1.519,0,0,1,0,2.142l-2.064,2.073a3.98,3.98,0,0,1-2.036,1.094l-2.919.586a3.968,3.968,0,0,1-1.748-.042L9.451,20.12A3.927,3.927,0,0,0,8.485,20h-1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M12.96,17h1.479a1.512,1.512,0,0,0,1.509-1.515v-.3a1.512,1.512,0,0,0-1.143-1.469l-2.283-.573A4.665,4.665,0,0,0,11.388,13h0a4.657,4.657,0,0,0-2.594.789L6.984,15"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M15.286,3.661l-.349.373-.35-.373A2.086,2.086,0,0,0,11.7,3.508h0a2.131,2.131,0,0,0-.257,2.943A20.518,20.518,0,0,0,14.937,10a20.7,20.7,0,0,0,3.57-3.645,2.048,2.048,0,0,0-.287-2.807l-.038-.033a2.09,2.09,0,0,0-2.9.146Z"
		})
	]
});
export default SvgHand;
